import { useTranslation } from 'react-i18next'
import { useRecoilValue } from 'recoil'
import { M3 } from '@messenger/consts'
import { applicationTypeAtom } from '@/atoms'
import { Button } from '@/components/priority/Button/Button'
import { Flex } from '@/components/priority/Flex/Flex'
import { Icon } from '@/components/priority/Icon/Icon'
import { Link } from '@/components/priority/Link/Link'
import { Text } from '@/components/priority/Text/Text'

export const SupportButton = () => {
  const { t } = useTranslation()
  const applicationType = useRecoilValue(applicationTypeAtom)

  const isM3 = applicationType === M3
  const supportEmail = isM3
    ? 'help@messengerllc.com'
    : 'dignitysupport@messengerllc.com'

  return (
    <Link href={`mailto:${supportEmail}`} target="_self" disabled={false}>
      <Button primary aria-label={t('package.supportButtonAriaLabel')}>
        <Flex gap="6px" center>
          <Icon icon="support" fill="lockedWhite" width="18px" height="18px" />
          <Text color="lockedWhite">{t('package.supportButton')}</Text>
        </Flex>
      </Button>
    </Link>
  )
}
